import { ApiSalesDashboardService } from 'services';

// ─── `GET /rules` de la Support API, para el modal ───────────────────────────
// El mismo cliente y el mismo sobre `{ success, data }` que la Mesa de cruces;
// un pedido chico propio para que el modal no dependa de la Mesa.

/**
 * La agencia de las reglas que usan el modal de autorización y "Códigos de comercio y cuotas", desde cualquier país: la
 * tabla fija del Power, su respaldo, es la suya, y con ella se sembró el ABM.
 */
export const MODAL_RULES_AGENCY_ID = 1;

/** Máximo de `limit` que acepta `GET /rules` (100 por defecto). */
export const BASE_RULES_MAX_LIMIT = 200;

/**
 * Las reglas vigentes de la agencia 1, tal como las manda la API: se validan después (`activeRulesFrom`). Falla si la
 * API falla o responde sin éxito.
 */
export async function getBaseCarrierRules(): Promise<unknown> {
	const res = await ApiSalesDashboardService.get<{ success?: boolean; data?: unknown }>('data/card-desk/rules', {
		params: { agencyId: MODAL_RULES_AGENCY_ID, active: true, limit: BASE_RULES_MAX_LIMIT },
	});
	if (!res.data?.success) throw new Error('La Support API respondió sin éxito en GET data/card-desk/rules');
	return res.data.data;
}
